"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeProvider = require("../../ThemeProvider");

var _events = _interopRequireDefault(require("../../utils/events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ScrollShowHOC =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollShowHOC, _Component);

  function ScrollShowHOC() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollShowHOC);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollShowHOC)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: false
    });

    _defineProperty(_assertThisInitialized(_this), "events", {
      resize: function resize() {
        return _this.recomputeState();
      },
      scroll: function scroll() {
        return _this.recomputeState();
      },
      touchstart: function touchstart() {
        return _this.recomputeState();
      },
      touchmove: function touchmove() {
        return _this.recomputeState();
      },
      touchend: function touchend() {
        return _this.recomputeState();
      },
      pageshow: function pageshow() {
        return _this.recomputeState();
      },
      load: function load() {
        return _this.recomputeState();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _events["default"].addEventsToDocument(_this.events);

      _this.recomputeState();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _events["default"].removeEventsFromDocument(_this.events);
    });

    _defineProperty(_assertThisInitialized(_this), "recomputeState", function () {
      var top = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);

      _this.setState({
        show: top > 100
      });
    });

    return _this;
  }

  _createClass(ScrollShowHOC, [{
    key: "render",
    value: function render() {
      if (!this.state.show) return null;
      return _react["default"].createElement("div", {
        className: this.props.theme.wrap
      }, this.props.children);
    }
  }]);

  return ScrollShowHOC;
}(_react.Component);

var _default = (0, _ThemeProvider.applyTheme)('ScrollShowHOC', ScrollShowHOC);

exports["default"] = _default;